<template>
  <div v-if="isVisible" class="methodology-modal">
    <button class=closebutton @click="closePopup">X</button>

    <div class="methodology">
      <h2>Project Methodology</h2>
      <p>
        This web application evaluates the feasibility of converting Class B and C buildings—identified with a vacancy
        rate over 15% into new and affordable housing units using a Residual Land Value (RLV) model. <br>Source: CoStar,
        2023
      </p>
      <ul>
        <li><strong>Inputs:</strong> Adjust sliders for square footage, affordable housing percentage, <a
            href="https://www.nyc.gov/site/hpd/services-and-information/area-median-income.page" target="_blank">AMI
            level</a>, and subsidies.</li>
        <li><strong>Outputs:</strong> Displays potential units and affordability.</li>
        <li><strong>Real-time Processing:</strong> Immediate updates to results upon input adjustments.</li>
        <li><strong> Calculations:</strong> Calculations involve taxes, revenue potential, costs, and subsidies to
          estimate ROI and feasibility.</li>
        <li><strong> Limitations:</strong> Results are approximations and should not be considered definitive. Market
          conditions and external factors can influence the actual outcomes.</li>
        <li><strong> Developer:</strong> Developed by Elene Jikia M.S. Data Visualization Thesis, Parsons New School for
          Design, 2024</li>
      </ul>


      <p>
        <strong>Contact:</strong> For further questions you may reach out to elene@newschool.edu
      </p>
    </div>
  </div>

</template>
<script>
export default {
  name: 'Methodology',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closePopup() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.methodology {
  position: relative;
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-family: 'Barlow Condensed', sans-serif;
}

.methodology-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
}

.methodology h2 {
  color: #333;
  font-size: 24px;

}

.methodology p,
.methodology li {
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

.methodology ul {
  list-style-type: none;
  padding: 0;
}

.methodology li {
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
}

.closebutton {
  position: absolute;
  top: 240px;
  /* Adjust as needed */
  right: 650px;
  /* Adjust as needed */
  border: none;
  background: none;
  color: rgb(98, 96, 96);
  font-size: 20px;
  height: 10px;
  /* Adjust size as needed */
  cursor: pointer;
}
</style>
